module.exports = __webpack_public_path__ + "static/media/29ADMSPC30.c1ecdc14.jpg";